import { render, staticRenderFns } from "./LanguageAbility.vue?vue&type=template&id=1fe791fe"
import script from "./LanguageAbility.vue?vue&type=script&lang=js"
export * from "./LanguageAbility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports